/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RenewAccessRequest
 */
export interface RenewAccessRequest {
    /**
     * 
     */
    contact_confirmed: RenewAccessRequestContactConfirmedEnum;
    /**
     * 
     */
    reason: string;
}


/**
 * @export
 */
export const RenewAccessRequestContactConfirmedEnum = {
    True: true,
} as const;
export type RenewAccessRequestContactConfirmedEnum = typeof RenewAccessRequestContactConfirmedEnum[keyof typeof RenewAccessRequestContactConfirmedEnum];


/**
 * Check if a given object implements the RenewAccessRequest interface.
 */
export function instanceOfRenewAccessRequest(value: object): value is RenewAccessRequest {
    if (!('contact_confirmed' in value) || value['contact_confirmed'] === undefined) return false;
    
    if (value['contact_confirmed'] !== true) return false;
    if (!('reason' in value) || value['reason'] === undefined) return false;
    return true;
}

export function RenewAccessRequestFromJSON(json: any): RenewAccessRequest {
    return RenewAccessRequestFromJSONTyped(json, false);
}

export function RenewAccessRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RenewAccessRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'contact_confirmed': json['contact_confirmed'],
        'reason': json['reason'],
    };
}

export function RenewAccessRequestToJSON(json: any): RenewAccessRequest {
    return RenewAccessRequestToJSONTyped(json, false);
}

export function RenewAccessRequestToJSONTyped(value?: RenewAccessRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contact_confirmed': value['contact_confirmed'],
        'reason': value['reason'],
    };
}

